import { Box, Flex, Stack } from '@chakra-ui/react';
import SidebarBrand from './Brand';
import SidebarLinks from './Links';
import { AppRoute } from '../../../routes';

interface SidebarContentProps {
	routes: AppRoute[];
}

export function SidebarContent(props: SidebarContentProps) {
	const { routes } = props;
	return (
		<Flex direction='column' height='100%' pt='20px' px='16px' borderRadius='0px'>
			<SidebarBrand />
			<Stack direction='column' mt='8px' mb='auto'>
				<Box>
					<SidebarLinks routes={routes} />
				</Box>
			</Stack>
		</Flex>
	);
}

export default SidebarContent;
